/**
 * @generated SignedSource<<f9cba6fa47be35b8ff9b01af282ec520>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "DeleteScheduleShiftChangeRequestPayload",
            "kind": "LinkedField",
            "name": "deleteScheduleShiftChangeRequest",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfScheduleShiftChangeRequest",
                    "kind": "LinkedField",
                    "name": "changeRequestEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ScheduleShiftChangeRequest",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ScheduleShiftChangeRequestDeleteChangeMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ScheduleShiftChangeRequestDeleteChangeMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "7a1fb744b6790c50e6127ed28fce4b04",
            "id": null,
            "metadata": {},
            "name": "ScheduleShiftChangeRequestDeleteChangeMutation",
            "operationKind": "mutation",
            "text": "mutation ScheduleShiftChangeRequestDeleteChangeMutation(\n  $model: DeleteScheduleShiftChangeRequestRequestInput!\n) {\n  deleteScheduleShiftChangeRequest(model: $model) {\n    changeRequestEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "878e21356c3ee7d215a0212992eabb05";
export default node;
